export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14644.12f511be.jpg";